import Vue from 'vue';

Vue.component('ratesdollarlist', require('./components/RatesDollarList.vue'));
Vue.component('cityplanreview', require('./components/CityPlanReview.vue'));



// WEBPACK FOOTER //
// ./Modules/CityPlan/Resources/assets/js/app.js